<template>
  <div class="asc-datacell--container">
    <a class="asc-datacell" @click="handleCellClick">
      <span v-if="index" class="asc-datacell--index">{{ index }}</span>
      <span class="asc-datacell--text">
        <span>{{ text }}</span>
      </span>
      <span class="asc-datacell--count">{{ count }}</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'AscDataCell',

  props: {
    index: {
      type: Number,
      default: undefined,
    },
    text: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    onCellClick: {
      type: Function,
      default: () => {},
    },
    to: {
      type: String,
      default: undefined,
    },
  },

  methods: {
    handleCellClick(event) {
      event.preventDefault()
      event.stopPropagation()
      if (this.to) {
        this.$router.push(this.to)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-datacell {
  &--container {
    font-size: $font-size-md;
    width: 100%;
    height: 100%;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

    .asc-datacell {
      display: flex;
      background: $gray-0;
      padding: 9px 8px;
      height: 100%;
      width: 100%;
      max-height: 104px;
      line-height: 18px;

      &--index {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        min-width: 24px;
        color: $primary-black;
      }

      &--text {
        color: $accent-700;
        text-align: left;
        flex: 1 1 auto;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;

        & > span {
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      &--count {
        display: flex;
        justify-content: flex-end;
        min-width: 35px;
        align-items: center;
        color: $primary-black;
      }

      &:hover {
        background-color: $accent-0;

        .asc-datacell--text {
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
